




import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_PAYMENT, DELETE_PAYMENT, GET_PAYMENT_ALL, UPDATE_PAYMENT, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllPayments = createAsyncThunk('getAllPayment', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_PAYMENT_ALL, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const PaymentAllSlice = createSlice({
    name: 'Invioce',
    initialState: {
        Payment: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllPayments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllPayments.fulfilled, (state, action) => {
                state.Payment = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllPayments.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const PaymentMerchantDetailsSlice = createSlice({
    name: 'Payment Merchant Dedail',
    initialState: {
        PaymentMerchantDeilal: ''
    },
    reducers: {
        setPaymentMerchantDetials: (state, action) => {
            state.PaymentMerchantDeilal = action.payload;
        }
    }
});

export const CreatePaymentMerchant = createAsyncThunk('createPaymentMerchant', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_PAYMENT, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdatePaymentMerchant = createAsyncThunk('updatePaymentMerchant', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_PAYMENT, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeletePaymentMerchant = createAsyncThunk('deletePaymentMerchant', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_PAYMENT, { paymentMerchantID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const {setPaymentMerchantDetials} = PaymentMerchantDetailsSlice.actions
export {
    PaymentAllSlice,
    PaymentMerchantDetailsSlice
};
